import { GridHeaders } from '@project-types/GridHeaders';
import { ShowReasonColumn } from '@pages/reporting-pages/ShowReasonColumn';



type ReasonProperties = { orderPlanningReason?: string | null, orderExecutionReason?: string | null }


export function checkOrdersHasReason<T extends ReasonProperties>(data: T[] | null | undefined, showReasonColumn: ShowReasonColumn): boolean {
	if (!data || data.length === 0) return false;

	if (showReasonColumn === ShowReasonColumn.planning) {
		return data.every(item => item.hasOwnProperty('orderPlanningReason') && item.orderPlanningReason);
	}

	if (showReasonColumn === ShowReasonColumn.execution) {
		return data.every(item => item.hasOwnProperty('orderExecutionReason') && item.orderExecutionReason);
	}

	return data.every(item =>
		(item.hasOwnProperty('orderPlanningReason') && item.orderPlanningReason)
		||
		(item.hasOwnProperty('orderExecutionReason') && item.orderExecutionReason)
	);
}



export function getHeadersObjectBase<T>(headers: GridHeaders<T>, showReasonColumn: ShowReasonColumn): GridHeaders<T> {
	return headers.filter(header => {
		switch (showReasonColumn) {
			case ShowReasonColumn.planning: return header.key !== 'orderExecutionReasonName';
			case ShowReasonColumn.execution: return header.key !== 'orderPlanningReasonName';
			case ShowReasonColumn.planningAndExecution: return true;
			default: return true;
		}
	})
}